import * as actions from "../actionTypes"

const initialState = {
    value: true,
}

export default function carouselVisible(state = initialState, action) {
    switch (action.type) {
        case actions.SET_CAROUSEL_VISIBLE: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
